"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainStrokePath = exports.WhiteCircle = exports.MainFillStrokePath = exports.MainCircle = exports.MainStrokeRect = exports.MainRect = exports.WhiteRect = exports.Background = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
exports.Background = styled_components_1.default.rect.attrs({ width: '416', height: '219', x: '0', y: '0' }) `
  fill: ${(0, wl_ui_kit_1.getColor)('background')};
`;
exports.WhiteRect = styled_components_1.default.rect.attrs({ rx: '2' }) `
  fill: ${(0, wl_ui_kit_1.getColor)('surface')};
`;
exports.MainRect = styled_components_1.default.rect `
  fill: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
`;
exports.MainStrokeRect = styled_components_1.default.rect.attrs({ rx: '1.85' }) `
  stroke: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  stroke-width: 0.3;
  stroke-opacity: 0.14;
`;
exports.MainCircle = styled_components_1.default.circle `
  fill: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
  stroke: ${(0, wl_ui_kit_1.getColor)('background')};
  stroke-width: 0.3;
`;
exports.MainFillStrokePath = styled_components_1.default.path `
  fill: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  fill-opacity: 0.14;
  stroke: ${(0, wl_ui_kit_1.getColor)('background')};
  stroke-width: 0.3;
`;
exports.WhiteCircle = styled_components_1.default.circle `
  fill: ${(0, wl_ui_kit_1.getColor)('background')};
`;
exports.MainStrokePath = styled_components_1.default.path `
  stroke: ${(0, wl_ui_kit_1.getColorShade)('onSurface', 'highEmphasis')};
  stroke-opacity: 0.14;
  stroke-width: 0.3;
`;
